import {
  faBan,
  faCog,
  faEdit,
  faSave,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useRef, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import { patientNotesGetAction } from "../../actions/patientAction";
import { getFullscriptTreamtmentplanList } from "../../actions/profileAction";
import AddNoteForm from "../../pages/Patients/AddNoteForm";
import ImageButton from "../ImageButton";
import { formatDate, getUserDetail } from "../../utils/helper";

import ContentLoader from "react-content-loader";
const PrescriptionNoteSection = ({
  closePopup,
  noteList,
  ppcId,
  patientInstruction,
  setPatientInstruction,
  pharmacyInstruction,
  setPharmacyInsytruction,
  notesOnPrescription,
  setNotesOnPrescription,
  fullscriptId,
  isFullscriptConnected,
}) => {
  const [activeSection, setActiveSection] = useState(0);
  const dispatch = useDispatch();
  const [treatmentPlanLoading, setTreatmentPlanLoading] = useState(true);
  const [activeNoteId, setActiveNoteId] = useState(0);
  const [showAddNoteForm, setShowAddNoteForm] = useState(false);
  const addRef = useRef(null);
  const editRef = useRef(null);
  const patientNotes = useSelector((state) => state.patient.activePatientNotes);
  const treatmentplanList = useSelector(
    (state) => state.profile.treatmentplanList
  );
  const patientAction = (cell, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div className="action-btn-wrapper row">
          <>
            <ImageButton
              text="Edit"
              icon={faEdit}
              onClick={() => setActiveNoteId(row.PPN_ID)}
            />
            <ImageButton
              text="Delete"
              icon={faTrash}
              isDelete="delete"
              onClick={() => {
                dispatch(
                  patientNotesGetAction(
                    "deletePatientNotes",
                    row.PPC_ID,
                    row.PPN_ID,
                    "",
                    () => {
                      dispatch(
                        patientNotesGetAction("getPatientNotes", row.PPC_ID)
                      );
                    }
                  )
                );
              }}
            />
          </>
        </div>
      </>
    );
  };

  useEffect(() => {
    if (ppcId > 0) {
      dispatch(patientNotesGetAction("getPatientNotes", ppcId));
    }
  }, [ppcId, dispatch]);

  useEffect(() => {
    if (patientInstruction == "") {
      setPatientInstruction("As directed by your health care professional");
    }
  }, []);

  useEffect(() => {
    if (isFullscriptConnected && fullscriptId) {
      var params = {
        params: {
          action: "getTreatmentplanList",
          token: getUserDetail()?.token,
          data: { fullscript_id: fullscriptId },
        },
      };
      dispatch(
        getFullscriptTreamtmentplanList(params, () => {
          setTreatmentPlanLoading(false);
        })
      );
    }
  }, [fullscriptId]);
  const columns = [
    {
      dataField: "PPN_Note",
      text: "Note",
      sort: false,
      formatExtraData: activeNoteId,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            {activeNoteId > 0 && activeNoteId === row.PPN_ID ? (
              <AddNoteForm
                hideFormAction={() => setActiveNoteId(0)}
                formRef={editRef}
                note={row.PPN_Note}
                noteId={row.PPN_ID}
                patientId={row.PPC_ID}
              />
            ) : (
              <p className="page-desc">{row.PPN_Note}</p>
            )}
          </>
        );
      },
    },
    {
      dataField: "PPN_Date_Created",
      text: "Date",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return formatDate(row.PPN_Date_Created);
      },
      headerStyle: {
        width: "100px",
      },
    },
    {
      dataField: "action",
      text: "Action",
      formatExtraData: activeNoteId,
      formatter: patientAction,
      headerFormatter: (column, colIndex) => {
        return <FontAwesomeIcon icon={faCog} />;
      },
      headerStyle: {
        width: "190px",
      },
    },
  ];

  const columnsPlans = [
    {
      dataField: "product",
      text: "Item",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>
              {row.product.name}{" "}
              {row.product.units ? "(" + row.product.units : ""}{" "}
              {row.product.unit_of_measure
                ? row.product.unit_of_measure + ")"
                : ""}{" "}
              {row.product.brand}
            </p>
          </>
        );
      },
    },
    {
      dataField: "recommendation",
      text: "Quantity",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{row.recommendation.units_to_purchase} unit(s)</p>
          </>
        );
      },
    },

    {
      dataField: "recommendation.dosage",
      text: "Dosage",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>
              {row.recommendation.dosage.amount}{" "}
              {row.recommendation.dosage.format}(s) (
              {row.recommendation.dosage.frequency})
            </p>
          </>
        );
      },
    },
    {
      dataField: "date",
      text: "Created Date",
      sort: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return (
          <>
            <p>{formatDate(row.date)}</p>
          </>
        );
      },
    },
  ];

  return (
    <div className="note-section">
      <div className="note-tab-wrapper">
        <div
          className={`note-tab ${activeSection === 0 ? "selected" : ""}`}
          onClick={() => setActiveSection(0)}
        >
          Patient Instructions
        </div>
        <div
          className={`note-tab ${activeSection === 1 ? "selected" : ""}`}
          onClick={() => setActiveSection(1)}
        >
          Pharmacy Instructions
        </div>
        <div
          className={`note-tab ${activeSection === 2 ? "selected" : ""}`}
          onClick={() => setActiveSection(2)}
        >
          Notes on Patient
        </div>
        <div
          className={`note-tab ${activeSection === 3 ? "selected" : ""}`}
          onClick={() => setActiveSection(3)}
        >
          Notes on Prescription
        </div>
        {fullscriptId ? (
          <div
            className={`note-tab ${activeSection === 4 ? "selected" : ""}`}
            onClick={() => setActiveSection(4)}
          >
            Fullscript Treatment Plan
          </div>
        ) : (
          ""
        )}
      </div>
      <div className="instruction-section">
        {activeSection === 0 && (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <p style={{ margin: "10px", fontSize: "18px" }} className="note">
                Add instructions for this prescription for the patient to read.
              </p>
              <p
                style={{ margin: "10px", fontSize: "14px", color: "red" }}
                className="note"
              >
                ({patientInstruction.length}/{195})
              </p>
            </div>

            <textarea
              maxLength={195}
              rows="6"
              placeholder="Enter note here..."
              value={patientInstruction}
              onChange={(e) => setPatientInstruction(e.target.value)}
            />
          </>
        )}
        {activeSection === 1 && (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <p style={{ margin: "10px", fontSize: "18px" }} className="note">
                Add preparation instructions for the pharmacy.
              </p>
              <p
                style={{ margin: "10px", fontSize: "14px", color: "red" }}
                className="note"
              >
                ({pharmacyInstruction.length}/{195})
              </p>
            </div>
            <textarea
              maxLength={195}
              rows="6"
              placeholder="Enter note here..."
              value={pharmacyInstruction}
              onChange={(e) => setPharmacyInsytruction(e.target.value)}
            />
          </>
        )}
        {activeSection === 2 && (
          <>
            <p style={{ margin: "10px", fontSize: "18px" }} className="note">
              Add and access any notes regarding this patient for your own
              records that only you will see.
            </p>
            <div className="add-section  mt-1 mr-1 ml-2">
              {showAddNoteForm && (
                <div className="row">
                  <div className="col-md-12">
                    <AddNoteForm
                      patientId={ppcId}
                      formRef={addRef}
                      hideFormAction={() => setShowAddNoteForm(false)}
                    />
                  </div>
                  {/* <div className="col-md-2">
                    <div className="action-btn-wrapper row">
                      <ImageButton
                        text="Save"
                        icon={faSave}
                        onClick={() => {
                          addRef.current.click();
                        }}
                      />

                      <ImageButton
                        text="Cancel"
                        icon={faBan}
                        isDelete="delete"
                        onClick={() => {
                          setShowAddNoteForm(false);
                        }}
                      />
                    </div>
                  </div> */}
                </div>
              )}

              <div className="button-section d-flex justify-content-start mr-1 mb-2">
                {!showAddNoteForm && (
                  <button
                    className=" btn-orange"
                    onClick={() => {
                      setShowAddNoteForm(true);
                    }}
                  >
                    Add Note
                  </button>
                )}
              </div>
            </div>
            {patientNotes.length > 0 && (
              <>
                <BootstrapTable
                  classes="react-bootstrap-table"
                  keyField="PPN_ID"
                  columns={columns}
                  data={patientNotes}
                  headerClasses="header-class"
                />
              </>
            )}
          </>
        )}
        {activeSection === 3 && (
          <>
            <div className="d-flex align-items-center justify-content-between">
              <p style={{ margin: "10px", fontSize: "18px" }} className="note">
                Add any notes regarding this prescription for your own records
                that only you will see.
              </p>
              <p
                style={{ margin: "10px", fontSize: "14px", color: "red" }}
                className="note"
              >
                ({notesOnPrescription.length}/{195})
              </p>
            </div>
            <textarea
              maxLength={195}
              rows="6"
              placeholder="Enter note here..."
              value={notesOnPrescription}
              onChange={(e) => setNotesOnPrescription(e.target.value)}
            />
          </>
        )}
        {activeSection === 4 && fullscriptId ? (
          <>
            <p style={{ margin: "10px", fontSize: "18px" }} className="note">
              Fullscript Treatment Plan List
            </p>
            {treatmentPlanLoading ? (
              <div>
                <ContentLoader
                  speed={2}
                  height={124}
                  width={500}
                  viewBox="0 0 500 124"
                  backgroundColor="#f3f3f3"
                  foregroundColor="#ffffff"
                >
                  <rect x="4" y="13" rx="3" ry="3" width="410" height="6" />
                  <rect x="4" y="29" rx="3" ry="3" width="380" height="6" />
                  <rect x="4" y="45" rx="3" ry="3" width="178" height="6" />
                </ContentLoader>
              </div>
            ) : (
              <>
                {treatmentplanList.length > 0 && (
                  <>
                    <BootstrapTable
                      classes="react-bootstrap-table"
                      columns={columnsPlans}
                      data={treatmentplanList}
                      keyField="id"
                      headerClasses="header-class"
                    />
                  </>
                )}
              </>
            )}
          </>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
export default PrescriptionNoteSection;
